import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputComponent } from './generic-input.component';
import { GenericCheckboxInputModule } from './generic-inputs/generic-checkbox-input/generic-checkbox-input.module';
import { GenericDateInputModule } from './generic-inputs/generic-date-input/generic-date-input.module';
import { GenericDaterangeInputModule } from './generic-inputs/generic-daterange-input/generic-daterange-input.module';
import { GenericDecimalInputModule } from './generic-inputs/generic-decimal-input/generic-decimal-input.module';
import { GenericMaskInputModule } from './generic-inputs/generic-mask-input/generic-mask-input.module';
import { GenericNumberInputModule } from './generic-inputs/generic-number-input/generic-number-input.module';
import { GenericPasswordInputModule } from './generic-inputs/generic-password-input/generic-password-input.module';
import { GenericSelectInputModule } from './generic-inputs/generic-select-input/generic-select-input.module';
import { GenericTextInputModule } from './generic-inputs/generic-text-input/generic-text-input.module';
import { GenericTextareaInputModule } from './generic-inputs/generic-textarea-input/generic-textarea-input.module';
import { GenericTriCheckboxInputModule } from './generic-inputs/generic-tri-checkbox-input/generic-tri-checkbox-input.module';
import { GenericDateTimeInputModule } from './generic-inputs/generic-date-time-input/generic-date-time-input.module';

export * from './generic-input.component';

@NgModule({
    declarations: [
        GenericInputComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        GenericTextInputModule,
        GenericPasswordInputModule,
        GenericSelectInputModule,
        GenericNumberInputModule,
        GenericDecimalInputModule,
        GenericTextareaInputModule,
        GenericCheckboxInputModule,
        GenericTriCheckboxInputModule,
        GenericDaterangeInputModule,
        GenericDateInputModule,
        GenericMaskInputModule,
        GenericDateTimeInputModule,
    ],
    exports: [
        GenericInputComponent,

    ],
})
export class GenericInputModule {
}
